import { createApi, createCustomServiceCall } from '@thinknimble/tn-models'
import { axiosInstance } from '../axios-instance'
import { userTokenShape, createUserTokenShape, userTokenCreatedShape } from './models'

/**
 * Mint a user token. Unlike the default `create`, the response carries the raw
 * `token` secret (surfaced exactly once), so it needs its own output shape.
 */
const createUserToken = createCustomServiceCall({
  inputShape: createUserTokenShape,
  outputShape: userTokenCreatedShape,
  cb: async ({ client, slashEndingBaseUri, input, utils: { fromApi, toApi } }) => {
    const response = await client.post(slashEndingBaseUri, toApi(input))
    return fromApi(response.data)
  },
})

export const userTokenApi = createApi({
  client: axiosInstance,
  baseUri: '/tokens/user-tokens/',
  models: {
    entity: userTokenShape,
  },
  customCalls: {
    createUserToken,
  },
})
